import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ActivateBizComponent } from './portals/instaciti/activate-biz/activate-biz.component';
import { OtpHandlerComponent } from './public/otp-handler/otp-handler.component';

const routes: Routes = [
  // {
  //   path: ' ',
  //   loadChildren: () => import('./public/public.module').then(m => m.PublicModule)
    
  // },
  
  // { path: '**', redirectTo: '' }

];

@NgModule({
  imports: [RouterModule.forRoot(routes,{
    scrollPositionRestoration: 'enabled'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
